export const nextStep = () => {
    return {
        type : "NextStep"
    }
}

export const prevStep = () => {
    return {
        type : "PrevStep"
    }
}

export const ChangeStep = (payload) => {
    return {
        type : "ChangeStep",
        payload : payload
    }
}